import { isUndefined } from 'lodash'

import { useSystemMessage } from '@shared/composables/use-system-message'
import { IMessage, INonQliqMessage } from '@shared/models/proto/base/messages'
import { isMoreThanDuration } from '@shared/utils/helpers/date-formatter'

export const isSameSender = (params: {
  previousMessage: IMessage | INonQliqMessage
  currentMessage?: IMessage | INonQliqMessage
}) => {
  const { previousMessage, currentMessage } = params

  if (!currentMessage) {
    return
  }

  const fiveMinutes = 5

  const currentMessageDate =
    (currentMessage as IMessage).actualStatus?.deliveredTime ||
    currentMessage?.createdAt

  const previousMessageDate =
    (previousMessage as IMessage)?.actualStatus?.deliveredTime ||
    previousMessage?.createdAt

  const isMoreThanFiveMinute = isMoreThanDuration(
    previousMessageDate,
    currentMessageDate,
    fiveMinutes
  )

  const isSameNonQliqSender =
    !isUndefined((previousMessage as INonQliqMessage)?.senderId) &&
    (previousMessage as INonQliqMessage)?.senderId ===
      (currentMessage as INonQliqMessage)?.senderId

  const isSameQliqSender =
    !isUndefined((previousMessage as IMessage)?.sender?.id) &&
    (previousMessage as IMessage)?.sender?.id ===
      (currentMessage as IMessage)?.sender?.id

  return (isSameQliqSender || isSameNonQliqSender) && !isMoreThanFiveMinute
}

export const isNewSender = (params: {
  previousMessage: IMessage | INonQliqMessage
  currentMessage?: IMessage | INonQliqMessage
}) => {
  const { previousMessage } = params
  const { isSystemMessage } = useSystemMessage(previousMessage?.messageType)
  const isSameSenderResult = isSameSender(params)

  return !isSameSenderResult || isSystemMessage.value
}
